import { addToCartDataLayer } from "./analytics-scripts"

function addToCart() {

    // Clear existing click listeners to prevent duplicate bindings
    $(document).off("click", '[data-btn="add-to-cart"]');
    $(document).off("click", ".cta-close-popup");
    /**
     * Add product to cart
     */
    $(document).on("click", '[data-btn="add-to-cart"]', function() {

        // Get fresh data at the time of click instead of relying on cached jQuery data
        const $this = $(this);
        const button = this;  // Native DOM element

        // Read attributes directly from the DOM element at click time
        const productId = button.getAttribute('data-product-id');
        const productVariantId = button.getAttribute('data-product-variant-id');
        const userId = button.getAttribute('data-user-id');

        let productData = $this.data('product');
        let productVariantData = $this.data('selected-variant');
        let listName = $this.data('list-name');
        let position = $this.data('position');

        axios.post('/api/shop/cart/add-product', {
            product_id: productId,
            product_variant_id: productVariantId,
            user_id: (userId == 'null' || isNaN(userId)) ? null : Number(userId),
        }).then( response => {

            addToCartDataLayer( productData, productVariantData, listName, position )

            $("#popup-wrapper").html( response.data.object.popupContent )
            $("#header-cart-icon-wrapper").html( response.data.object.headerCartIconContent )

            return $(".free-delivery-slider").slick({
                arrows: true,
                dots: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 3,
                variableWidth: true,
                prevArrow: "<div class='slick-prev'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 5L9 12L16 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
                nextArrow: "<div class='slick-next'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 5L16 12L9 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 577,
                        settings: {
                            arrows: false,
                            slidesToShow: 2
                        }
                    }
                ]
            })

        }).catch( errors => { console.log( errors.response.data.errors ) })
    })

    /**
     * Close POP-UP
     */
    $(document).on("click", ".cta-close-popup", function() {
        $(this).closest(".popup-wrapper").fadeOut(300)

        setTimeout(() => {
            $(this).closest("#popup-wrapper").html("")
        }, 300);
    })

}

$(document).ready( function() {
    addToCart()
})

document.addEventListener('livewire:initialized', function () {
    // Event listener for selectVariant
    Livewire.on('selectVariant', () => {
        // Use setTimeout to ensure DOM is updated before reading the value
        setTimeout(() => {
            // Force refresh jQuery's data cache
            $('[data-btn="add-to-cart"]').each(function() {
                const element = $(this);
                const dataProductVariantId = $(this).attr('data-product-variant-id');

                // Update jQuery's internal data cache with current DOM values
                element.data('product-variant-id', dataProductVariantId);

                // Also update the selected-variant data if it exists
                if ($(this).attr('data-selected-variant')) {
                    // Parse the JSON, update the ID, and set it back
                    let variantData = element.data('selected-variant');
                    if (variantData && typeof variantData === 'object') {
                        variantData.id = dataProductVariantId;
                        element.data('selected-variant', variantData);
                    }
                }
            });
        }, 50);
    });
});
